import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './@auth/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'cms', pathMatch: 'full' },
  {
    path: 'cms',
    canActivate: [AuthGuard],
    loadChildren: () => import('./cms/cms.module').then((m) => m.CmsModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./@auth/pages/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
